// config.js - Configuration for different environments

/**
 * Get the configuration based on the current environment
 * @returns {Object} Configuration object with API settings
 */
export function getConfig() {
    // Determine environment - can be set through build process or defaults to development
    const env = import.meta.env?.VITE_APP_ENV || import.meta.env?.MODE || 'dev';

    // Base configurations
    const configs = {
      dev: {
        apiEndpoint: 'https://api1.cavs.com/survey-dev',
        apiKey: '49jg09j9asjhshij3aqjgmsrD',
        environment: 'development'
      },
      test: {
        apiEndpoint: 'https://api1.cavs.com/survey-test',
        apiKey: '49jg09j9asjhshij3aqjgmsrT',
        environment: 'test'
      },
      prod: {
        apiEndpoint: 'https://api1.cavs.com/survey',
        apiKey: '49jg09j9asjhshij3aqjgmsrP',
        environment: 'prod'
      }
    };

    const config = configs[env] || configs.dev;

    // Use build-injected API endpoint if available (from CI/CD pipeline)
    if (import.meta.env?.VITE_API_ENDPOINT) {
      config.apiEndpoint = import.meta.env.VITE_API_ENDPOINT.replace(/\/$/, '');
    }

    return config;
  }
  
  // For local development/testing, add some mock data if needed
  export const MOCK_DATA = {
    recommendations: {
      'PREMIUM': {
        title: 'Premium Membership',
        description: 'Our most exclusive package with all perks included',
        price: '$10,000/season',
        benefits: [
          'Priority access to playoff tickets',
          'VIP entrance',
          'Exclusive events with players',
          'Premium seating'
        ]
      },
      'STANDARD': {
        title: 'Standard Membership',
        description: 'Great value for serious fans',
        price: '$5,000/season',
        benefits: [
          'Guaranteed regular season tickets',
          'Member-only merchandise',
          'Concession discounts'
        ]
      },
      'BASIC': {
        title: 'Basic Membership',
        description: 'Perfect for new fans',
        price: '$2,500/season',
        benefits: [
          'Access to ticket pre-sales',
          'Member communications',
          'Merchandise discounts'
        ]
      }
    }
  };